module.exports = __webpack_public_path__ + "9cc1fbd3efdfccd4845dc2a940182728.gif";